import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import InfoIcon from 'react-material-icons/icons/action/info';
import DealerFilters from '../DealerFilters';
import DealersCounter from '../DealersCounter';
import './index.css';

const propTypes = {
  filteredDealersList: PropTypes.array.isRequired,
  isHolidayMode: PropTypes.bool.isRequired,
};

const MdtStatusLayout = props => {
  return (
    <div className="MdtStatusLayout">
      <div className="MdtStatusLayout__content">
        {props.isHolidayMode && (
          <div className="MdtStatusLayout__holiday_mode_wrapper">
            <div className="MdtStatusLayout__holiday_mode_msg">
              <InfoIcon className="MdtStatusLayout__holiday_mode_icon" />
              <strong className="MdtStatusLayout__holiday_mode_text">
                <FormattedMessage
                  id="mdt.opening_times_status.holiday_message"
                  defaultMessage="Holiday mode"
                />
              </strong>
            </div>
          </div>
        )}
        <div className="MdtStatusLayout__col MdtStatusLayout__col--left">
          <DealerFilters {...props} />
        </div>
        <div className="MdtStatusLayout__col MdtStatusLayout__col--right">
          <div className="MdtStatusLayout__counter_wrapper">
            <DealersCounter dealerList={props.filteredDealersList} />
          </div>
        </div>
      </div>
    </div>
  );
};

MdtStatusLayout.propTypes = propTypes;

export default MdtStatusLayout;



// WEBPACK FOOTER //
// ../ui-components/components/MdtStatusLayout/index.jsx